<div id="chartWrapper" style="position:relative">
  <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>

    <ng-container *ngIf="chartObject">
      <ng-container *ngIf="chartObject.totalCharts > 1">
      <button *ngIf="hasPrevious()" type="button"
          [ngClass]="{'slide-prev': true, 'slide-arrow' :true, 'is-popup': isExpandChart}" 
          aria-label="Previous" 
          role="button" 
          (click)="previousChart($event)">Previous</button>
      <button *ngIf="hasNext()" type="button" 
        [ngClass]="{'slide-next': true, 'slide-arrow': true, 'is-popup': isExpandChart}" 
        aria-label="Next"
        role="button"
        (click)="nextChart($event)">Next</button>
      </ng-container>
    </ng-container>

    <div class="charter custom-scrollbar" [class.in-popup]="isExpandChart"
    [ngStyle]="{'height': 'calc(100% - ' + filledSpace + 'rem)'}">
      <ng-container *ngIf="chartObject; else noChart">
        <div id="chartContainer" [class.multiple-charts]="chartObject.totalCharts > 1">
          <ng-container *ngIf="chartObject.chartOptions; else noChart">
            <div class="chart-settings" (click)="onContextMenu($event)"><mat-icon>menu</mat-icon></div>
            <lib-highcharts-angular
              [Highcharts]="Highcharts"
              [constructorType]="chartConstructor"
              [options]="chartObject.chartOptions"
              [callbackFunction]="chartCallback"
              [(update)]="updateFlag"
              [oneToOne]="oneToOneFlag"
              [ngStyle]="{'width': '100%','display':'block','height':'calc(100% - 0rem)' }"></lib-highcharts-angular>
          </ng-container>
        </div>   
      </ng-container>
      <ng-template #noChart>
        <div id="chartContainer">
          <div class="chart-empty" [ngStyle]="{'height': 'calc(100% - ' + filledSpace + 'rem)'}">
            <div *ngIf="!isBusy" class="no-item-container">
              <p>You have not configured any reports</p>
            </div>
          </div>
        </div>
      </ng-template>
        <!-- <div id="pagination" *ngIf="currentChart">Page <span>{{ currentChart }}</span> of <span>{{ totalCharts }}</span></div> -->
         
    </div>
</div>
<context-menu [useBootstrap4]="true">
  <ng-template contextMenuItem (execute)="showAll()">
    Show All
  </ng-template>
  <ng-container *ngIf="!isExpandChart && showExpand">
    <ng-template contextMenuItem (execute)="expandChart()">
      Expand
    </ng-template>
  </ng-container>
</context-menu>